// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._772176~*{margin-left:-0.25em}.a12440{margin-left:-0.5em;transform:none}.a12440+.a12440{margin-left:-0.75em;margin-right:-0.5em}.c3ccf7{text-align:center}", ""]);
// Exports
exports.locals = {
	"icon": "_772176",
	"chevron": "a12440",
	"period": "c3ccf7"
};
module.exports = exports;
